import Swiper from 'swiper'
import SwiperCore, { Navigation, Lazy } from 'swiper/core'

SwiperCore.use([Navigation, Lazy])

export default class ArticleTwoColumnGallery {
  constructor(component) {
    this.refs = {
      container: '.js-articleTwoColumnGalleryContainer',
      prev: '.js-articleTwoColumnGalleryPrev',
      next: '.js-articleTwoColumnGalleryNext',
      slides: '.js-slideContainer',
      link: '.js-link',
    }

    this.dom = {
      $component: component,
      $container: component.querySelector(this.refs.container),
      $slides: component.querySelectorAll(this.refs.slides),
    }

    this.state = {
    }

    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.initSlider()
    this.linkClickHandler()
  }

  linkClickHandler() {
    const { dom } = this
    dom.$slides.forEach((slide) => {
      slide.addEventListener('click', () => this.urlRedirect(slide))
    })
  }

  urlRedirect(element) {
    const link = element.querySelector(this.refs.link)

    if (link) window.location.href = link.href
  }

  initSlider() {
    const { dom, state, refs } = this

    if (!dom.$container) return

    const { id } = dom.$container.dataset
    const ref = `${refs.container}.swiper-ref-${id}`
    state.swiper = new Swiper(ref, {
      slidesPerView: 'auto',
      loop: true,
      lazy: true,
      effect: 'fade',
      navigation: {
        prevEl: `${refs.prev}-${id}`,
        nextEl: `${refs.next}-${id}`,
      },
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ArticleTwoColumnGallery = this
  }
}
